export default "/kiban/_next/static/images/pieceCnt-a0de9eaa276a171f33241e767e4390e7.png";